import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['paymentMethod', 'phoneFields', 'bankFields', 'payoutFields', 'feesInfo']
  static values = { feeRates: Object }

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const method = this.paymentMethodTarget.value
    const isBank = method === 'bank'
    const isMobile = method === 'my_nita' || method === 'amana'
    const isPayout = method === 'payout'

    this.phoneFieldsTarget.classList.toggle('is-hidden', !isMobile)
    this.bankFieldsTarget.classList.toggle('is-hidden', !isBank)
    this.payoutFieldsTarget.classList.toggle('is-hidden', !isPayout)

    if (this.hasFeesInfoTarget) {
      this.updateFeesInfo(method)
    }
  }

  updateFeesInfo(method) {
    const rate = this.hasFeeRatesValue ? (this.feeRatesValue[method] ?? 0) : 0
    const percent = (rate * 100).toFixed(0)
    const el = this.feesInfoTarget

    if (rate === 0) {
      el.className = 'notification is-warning is-light is-default py-3 px-4'
      el.innerHTML = '<strong>Gratuit : 0% de frais</strong> — aucun frais ne sera prélevé sur vos reversements.'
    } else {
      el.className = 'notification is-warning is-light is-default py-3 px-4'
      el.innerHTML = `<strong>Frais de retrait : ${percent}%</strong> — appliqués sur le montant total de chaque demande de reversement.<br><span class="is-size-7">Exemple : pour 10 000 FCFA reversés, ${(10000 * rate).toLocaleString('fr-FR')} FCFA de frais seront prélevés.</span>`
    }
  }
}
